module.exports = __webpack_public_path__ + "static/media/1.d3515f77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/16006/1.jpg
// module id = 499
// module chunks = 0